import { render, staticRenderFns } from "./HvPill.vue?vue&type=template&id=57e12012"
import script from "./HvPill.vue?vue&type=script&lang=js"
export * from "./HvPill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports